import { render, staticRenderFns } from "./NewRealEstateList.vue?vue&type=template&id=dc6d7798&scoped=true&"
import script from "./NewRealEstateList.vue?vue&type=script&lang=js&"
export * from "./NewRealEstateList.vue?vue&type=script&lang=js&"
import style0 from "./NewRealEstateList.vue?vue&type=style&index=0&id=dc6d7798&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6d7798",
  null
  
)

export default component.exports